"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _emotionTheming = require("emotion-theming");

var _NormalButton = _interopRequireDefault(require("../../Button/NormalButton"));

var _AccentButton = _interopRequireDefault(require("../../Button/AccentButton"));

var _Checkbox = _interopRequireDefault(require("../../Checkbox"));

var _Radio = _interopRequireDefault(require("../../Radio"));

var _FilterControls = require("./FilterControls.style");

/* eslint jsx-a11y/no-static-element-interactions: 0 */
var stop = function stop(e) {
  return e.stopPropagation();
};

var FilterControls =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(FilterControls, _PureComponent);

  function FilterControls(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FilterControls);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FilterControls).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleOutsideClick", function (_ref) {
      var target = _ref.target;
      if (_this.wrap && _this.wrap.contains(target)) return;

      if (_this.props.filterDropdownVisible === null || _this.props.filterDropdownVisible === undefined) {
        _this.setState({
          expanded: false
        });
      } else {
        _this.props.onFilterDropdownVisibleChange(false);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleStickyHeader", function (expanded) {
      if (_this.props.fixedHeader) {
        var tableHeader = document.querySelectorAll('.table-header');

        if (tableHeader && tableHeader[0]) {
          var height = document.querySelectorAll('header table')[0] && document.querySelectorAll('header table')[0].offsetHeight;
          var threshold = parseFloat(_this.props.top);

          if (tableHeader[0].getBoundingClientRect().y > -height + threshold) {
            return;
          }
        }

        var header = document.querySelectorAll('header');

        if (expanded) {
          setTimeout(function () {
            header.forEach(function (item) {
              item.style.height = '100vh';
            });
          });
        } else {
          header.forEach(function (item) {
            item.style.height = 'unset';
          });
        }
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "toggle", function () {
      _this.props.onFilterDropdownVisibleChange(!_this.state.expanded);

      if (_this.props.filterDropdownVisible === null || _this.props.filterDropdownVisible === undefined) {
        _this.setState({
          expanded: !_this.state.expanded
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "submit", function (e) {
      e && e.preventDefault();
      var columnKey = _this.props.columnKey;
      var valueNodes = _this.form[columnKey];

      var result = _this.props.filters.reduce(function (acc, _ref2, valueIndex) {
        var value = _ref2.value;
        var inputChecked = valueNodes[valueIndex].checked;
        if (!inputChecked) return acc;
        return [].concat((0, _toConsumableArray2.default)(acc), [value]);
      }, []);

      _this.props.filterTable(_this.props.columnKey, result);

      _this.toggle();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "setFormRef", function (node) {
      _this.form = node;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "setWrapRef", function (node) {
      _this.wrap = node;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "resetForm", function () {
      var columnKey = _this.props.columnKey;
      var valueNodes = _this.form[columnKey];
      valueNodes.forEach(function (node) {
        node.checked = false;
      });

      _this.submit();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderFilterComponent", function () {
      var _this$props = _this.props,
          filters = _this$props.filters,
          filterSingle = _this$props.filterSingle,
          colFiltersApplied = _this$props.colFiltersApplied,
          theme = _this$props.theme,
          columnKey = _this$props.columnKey,
          filterDropdown = _this$props.filterDropdown;
      var FilterComponent = filterSingle ? _Radio.default : _Checkbox.default;

      if (filterDropdown && _react.default.isValidElement(filterDropdown)) {
        return _this.props.filterDropdown;
      }

      return _react.default.createElement("form", {
        ref: _this.setFormRef,
        onSubmit: _this.submit,
        className: (0, _FilterControls.formStyle)(theme)
      }, filters.map(function (_ref3) {
        var label = _ref3.label,
            value = _ref3.value;
        return _react.default.createElement(FilterComponent, {
          key: value,
          label: label,
          name: columnKey,
          defaultChecked: colFiltersApplied.includes(value),
          className: (0, _FilterControls.labelStyle)(theme)
        });
      }), _react.default.createElement("div", {
        className: (0, _FilterControls.footerStyle)(theme)
      }, _react.default.createElement(_AccentButton.default, {
        text: "OK",
        type: "submit"
      }), _react.default.createElement(_AccentButton.default, {
        text: "Reset",
        onClick: _this.resetForm
      })));
    });
    _this.state = {
      expanded: _this.props.filterDropdownVisible
    };
    return _this;
  }

  (0, _createClass2.default)(FilterControls, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.filterDropdownVisible !== nextProps.filterDropdownVisible) {
        this.state.expanded = nextProps.filterDropdownVisible;
      } // this.state.expanded = !!nextProps.filterDropdownVisible;

    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('click', this.handleOutsideClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleOutsideClick);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          filters = _this$props2.filters,
          colFiltersApplied = _this$props2.colFiltersApplied,
          theme = _this$props2.theme,
          filterDropdown = _this$props2.filterDropdown,
          popupOnRight = _this$props2.popupOnRight,
          filterIconName = _this$props2.filterIconName;
      if ((0, _isEmpty.default)(filters) && filterDropdown === null) return null;
      var expanded = this.state.expanded;
      this.handleStickyHeader(expanded);
      var selected = expanded || colFiltersApplied.length;
      return _react.default.createElement("div", {
        className: (0, _FilterControls.filterControlStyle)(theme),
        ref: this.setWrapRef,
        onClick: stop
      }, _react.default.createElement(_NormalButton.default, {
        onClick: this.toggle,
        icon: {
          type: filterIconName,
          className: (0, _FilterControls.iconStyles)(theme, selected)
        }
      }), expanded && _react.default.createElement("div", {
        className: (0, _FilterControls.popoverStyle)(theme, popupOnRight)
      }, this.renderFilterComponent()));
    }
  }]);
  return FilterControls;
}(_react.PureComponent);

FilterControls.defaultProps = {
  filters: null,
  filterSingle: false,
  filterDropdown: null,
  filterDropdownVisible: undefined,
  filterIconName: 'filter',
  popupOnRight: false,
  onFilterDropdownVisibleChange: function onFilterDropdownVisibleChange() {}
};
FilterControls.propTypes = {
  theme: _propTypes.default.shape({}).isRequired,
  columnKey: _propTypes.default.string.isRequired,
  filterTable: _propTypes.default.func.isRequired,
  filterDropdown: _propTypes.default.element,
  filterDropdownVisible: _propTypes.default.bool,
  filters: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.string
  })),
  filterSingle: _propTypes.default.bool,
  colFiltersApplied: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  filterIconName: _propTypes.default.string,
  popupOnRight: _propTypes.default.bool,
  onFilterDropdownVisibleChange: _propTypes.default.func,
  fixedHeader: _propTypes.default.bool,
  top: _propTypes.default.string
};

var _default = (0, _emotionTheming.withTheme)(FilterControls);

exports.default = _default;